import {
  FontName,
  CHART_FONTS,
  FIGURE_TYPE_OPTIONS,
  FIGURE,
} from "./chartConfig"
import { pickTarget } from "redux/ducks/Chart"
import _ from "lodash"

interface figureTypeParam {
  [key: string]: number
}

const FIGURE_TYPE_PARAM: figureTypeParam = {
  create: 0,
  line: 0,
  infiniteline: 7,
  horizontal: 8,
  fan: 2,
  grid: 3,
  retracement: 4,
  expansion: 5,
  timezone: 6,
  fibofan: 10,
  arc: 11,
}

const FIGURE_COLOR_PROPATY = {
  line: ["trendLine", "TrendLine"],
  infiniteline: ["trendLine", "TrendLine"],
  horizontal: ["trendLine", "TrendLine"],
  retracement: ["Fibo", "FiboReTracement"],
  expansion: ["Fibo", "FiboExpansion"],
  timezone: ["Fibo", "FiboTimeZone"],
  fibofan: ["Fibo", "FiboFan"],
  arc: ["Fibo", "FiboArc"],
  fan: ["Gann", "GannFan"],
  grid: ["Gann", "GannGrid"],
}

export const setFigure = (
  figureType: string,
  figureOptions: any,
  fontType: string,
  colorSetting: object,
  _controller: any
) => {
  if (_.isEmpty(figureOptions)) return _controller.Chart.SetViewOpNone()

  let pms = getFigureLinesParams(figureOptions, figureType, colorSetting)
  _controller.Chart.DrawFigure(
    FIGURE_TYPE_PARAM[figureType],
    function() {
      return {
        Name: FontName,
        Size: 15 + Number(CHART_FONTS[fontType]),
        Type: {
          $: 1,
        },
      }
    },
    function() {
      return pms[0]
    },
    function() {
      return pms[1]
    },
    function() {
      return pms[2]
    },
    { $: 1, $0: 2 }
  )
}
// フィボナッチ・ギャン作成時のパラメータ取得
const getFigureLinesParams = (
  params: any,
  figureType: string,
  colorSetting: object
) => {
  let lines: Array<number | null> = []
  let sticks: Array<boolean | null> = []
  const withoutParam = _.without(
    params,
    FIGURE_TYPE_OPTIONS[0],
    FIGURE_TYPE_OPTIONS[1]
  )
  sticks.push(!!_.find(params, _.pick(FIGURE_TYPE_OPTIONS[0], pickTarget)))
  sticks.push(!!_.find(params, _.pick(FIGURE_TYPE_OPTIONS[1], pickTarget)))
  if (figureType === FIGURE[2].type[2].key) {
    // timezone以外は％がつく為、削除して文字列にする。
    _.forEach(withoutParam, item => lines.unshift(Number(item.key)))
  } else {
    _.forEach(withoutParam, item =>
      lines.unshift(Number(item.key.slice(0, -1)))
    )
  }
  const targetPath = _.get(FIGURE_COLOR_PROPATY, figureType, [])
  if (_.isEmpty(targetPath)) return [lines, sticks, 1]

  const path = _.join(["toolColor", ...targetPath], ".")
  const pvals = _.get(colorSetting, path)
  let vals = pvals ? pvals.split(";") : []
  let font = vals.length > 1 ? Number(vals[1]) : 1
  return [lines, sticks, font]
}

export const setFigureCommand = (
  figureCommandKey: string,
  _controller: any,
  callback: Function | null = null
) => {
  switch (figureCommandKey) {
    case "move":
      _controller.Chart.SetMoveDItem(false)
      break
    case "remove":
      _controller.Chart.SetDeleteDItem()
      break
    case "copy":
      _controller.Chart.SetMoveDItem(true)
      break
    case "allremove":
      _controller.Chart.SetDeleteAllDItem()
      if (callback) callback()
      break
  }
}
